// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contactInformation":"czMf-","details":"nqU-U","email":"ePhQb"};